import { useLocation } from "@tanstack/react-router";
import { useEffect } from "react";

import { useUpgradeFlowAnalytics } from "../useUpgradeFlowAnalytics";

export const UpgradeFlowAnalyticsTracker = () => {
  const location = useLocation();
  const { trackUpgradeFlowPathChange } = useUpgradeFlowAnalytics();

  useEffect(() => {
    trackUpgradeFlowPathChange(location.pathname);
  }, [location.pathname, trackUpgradeFlowPathChange]);

  return null;
};
